export default __webpack_public_path__ + "static/media/product_not_found.541c3aa1.svg";